import { MessageDarkOrangeIcon } from "../../../../../assets/icons";
import { OrderItemInfoDTO } from "../../../../../models/shared/response";


interface OrderItemView1Props {
    item: OrderItemInfoDTO;
}

const OrderItemView1: React.FC<OrderItemView1Props> = ({ item }) => {

    return (
        <div className="lo-table-order-product-div" key={item.id}>
            <div className="lo-table-order-product-count-div">
                <div>{item.quantity}x</div>
            </div>
            <div className="lo-table-order-product-info-div" id="w-node-_1aaaa707-3020-e515-a7c8-1af424701876-1cee91cf">
                <div className="lo-table-order-product-name">{item.productName}<span className="text-span-10"> /{item.productVariantLabel}</span></div>
                <div className="lo-table-order-product-description">{item.productDescription}</div>
                {/* <div className="lo-table-order-product-description-2">{itemDescription2}</div> */}
                {item.description && (
                    <div className="lo-table-order-product-message">
                        <img loading="lazy" src={MessageDarkOrangeIcon} alt="" className="icon-size-12" />
                        <div>{item.description}</div>
                    </div>
                )}
            </div>
            <div className="lo-table-order-product-price-div">
                <div className="lo-table-order-product-sum-price">{item.productVariantPrice * item.quantity} RSD</div>
                <div className="description-text product-price">{item.productVariantPrice} RSD/kom</div>
            </div>
        </div>
    );
};

export default OrderItemView1;